import styled from "@emotion/styled";
import { TERTIARY_GREY } from "src/constants/colors";

export const ModalOverlay = styled.div<{ isAnimating: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  opacity: ${({ isAnimating }) => (isAnimating ? 1 : 0)};
  transition: opacity 300ms ease-in-out;
`;

export const ModalContainer = styled.div<{ isAnimating: boolean }>`
  position: relative;
  background-color: #fafafb;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  transform: translateY(${({ isAnimating }) => (isAnimating ? "0" : "20px")});
  opacity: ${({ isAnimating }) => (isAnimating ? 1 : 0)};
  transition:
    transform 300ms ease-out,
    opacity 300ms ease-out;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: ${TERTIARY_GREY};
`;
